var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.983,
    height: 33.411,
    viewBox: "0 0 24.983 33.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "password-icon",
    d: "M54.472,55.533a1.934,1.934,0,0,1-.962,1.656v4.217H51.587V57.191a1.932,1.932,0,1,1,2.885-1.658Zm10.511-4.915V64.475A2.915,2.915,0,0,1,62.1,67.411H42.886A2.916,2.916,0,0,1,40,64.475V50.618a2.915,2.915,0,0,1,2.886-2.936h.047V43.79a9.618,9.618,0,1,1,19.233,0v3.9A2.913,2.913,0,0,1,64.983,50.618ZM44.854,47.679H60.242V43.788a7.695,7.695,0,1,0-15.387,0ZM63.06,50.618a.966.966,0,0,0-.895-.965v.008H42.933v-.021h-.047a.972.972,0,0,0-.962.978V64.475a.972.972,0,0,0,.962.978H62.1a.972.972,0,0,0,.962-.977Z",
    transform: "translate(-40 -34)",
    fill: "#2371a5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.7af15bf7.svg";
export { ForwardRef as ReactComponent };